export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({
    Ok: IDL.Vec(IDL.Principal),
    Err: IDL.Null,
  })
  const Result_1 = IDL.Variant({ Ok: IDL.Bool, Err: IDL.Text })
  return IDL.Service({
    entries: IDL.Func([], [Result], ['query']),
    status: IDL.Func([], [Result_1], []),
    statusV2: IDL.Func([IDL.Nat64], [Result_1], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
